import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import images from "../components/images"; 
import imagesFT from "../data/imagesFT.json";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Contact = () => {
  const formInitialDetails = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: ''
  }

  const [formDetails, setFormDetails] = useState(formInitialDetails);
  const [buttonText, setButtonText] = useState('Send');

  const onFormUpdate = (category, value) => {
    setFormDetails({
      ...formDetails,
      [category]: value
    });
  };

  // NEUE handleSubmit-Funktion (öffnet Mail-Client)
  const handleSubmit = (e) => {
    e.preventDefault();

    const to = "schriftfuehrer@felsenteufel.de";
    const subject = `Kontaktanfrage von ${formDetails.firstName} ${formDetails.lastName}`;

    const body =
      `Vorname: ${formDetails.firstName}\n` +
      `Nachname: ${formDetails.lastName}\n` +
      `E-Mail: ${formDetails.email}\n` +
      `Telefon: ${formDetails.phone}\n\n` +
      `Nachricht:\n${formDetails.message}`;

    // Mailto-Link dynamisch erzeugen
    const mailtoLink =
      `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    // Lokales E-Mail-Programm öffnen
    window.location.href = mailtoLink;

    // Optional: Formular zurücksetzen
    setFormDetails(formInitialDetails);
  };

  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="align-items-center">
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <img
                  className={isVisible ? "animate__animated animate__zoomIn" : ""}
                  src={images[imagesFT.poster]}
                  alt="Poster"
                />
              }
            </TrackVisibility>
          </Col>

          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <h2>Kontaktformular</h2>

                  <form onSubmit={handleSubmit}>
                    <Row>
                      <Col size={12} sm={6} className="px-1">
                        <input
                          type="text"
                          value={formDetails.firstName}
                          placeholder="Vorname*"
                          onChange={(e) => onFormUpdate('firstName', e.target.value)}
                        />
                      </Col>

                      <Col size={12} sm={6} className="px-1">
                        <input
                          type="text"
                          value={formDetails.lastName}
                          placeholder="Nachname*"
                          onChange={(e) => onFormUpdate('lastName', e.target.value)}
                        />
                      </Col>

                      <Col size={12} sm={6} className="px-1">
                        <input
                          type="email"
                          value={formDetails.email}
                          placeholder="E-Mail-Adresse*"
                          onChange={(e) => onFormUpdate('email', e.target.value)}
                        />
                      </Col>

                      <Col size={12} sm={6} className="px-1">
                        <input
                          type="tel"
                          value={formDetails.phone}
                          placeholder="Handynummer"
                          onChange={(e) => onFormUpdate('phone', e.target.value)}
                        />
                      </Col>

                      <Col size={12} className="px-1">
                        <textarea
                          rows="6"
                          value={formDetails.message}
                          placeholder="Nachricht"
                          onChange={(e) => onFormUpdate('message', e.target.value)}
                        ></textarea>

                        <button type="submit">
                          <span>{buttonText}</span>
                        </button>
                      </Col>
                    </Row>
                  </form>

                  <h6>
                    Postadresse: Felsenteufel Bühlertal e.V. - Postfach 12 - 77828 Bühlertal<br />
                    Schriftführer: schriftfuehrer@felsenteufel.de
                  </h6>
                </div>
              }
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
